import { JsonSchemaPianificazionePropertiesFormProperties } from "./campaign-3.model";

export class CouponProductsTargetForm{
  name: string;
  valid: boolean;
  schema: JsonSchemaPianificazionePropertiesFormProperties;
}

export class AreaGeo{
codice: string;
descrizione: string;
flg_dpl: string;
flg_kf: string;
flg_state: string;
}

export class Group{
  code: string;
  id: number;
  name: string;
  flg_state: string;
  flg_kf: string;
  flg_dpl: string;
}

export class Insegna{
  codice: string;
  insegna: string;
}

export class Campaign3Wizard{
  code: string;
  description: string;
  discount_type_id: number;
  flg_dpl: string;
  flg_kf: string;
  flg_state: string;
  id: number;
  name: string;
  promo_emission:any;
  scope: string;
  tag: string;
  target_loyalty_class: any;
}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/models/campaign-3-touchpoint.model.ts